import "./App.css";
import Dashboard from "./Dashboard";

function App() {
  return (
    <div className="App">
      <h1 className="title">Smart Dustbin Dashboard</h1>
      <Dashboard />
    </div>
  );
}

export default App;
